import { createSlice } from "@reduxjs/toolkit";
import { Patient } from "risa-data-model";
import { FirestoreService } from "../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../shared/api/firebase/references";
import { AppDispatch, DataState } from "../store/store";

const initialState: DataState<Patient> = {
  data: null,
  loading: false,
  error: null,
};

const singlePatientSlice = createSlice({
  name: "singlePatient",
  initialState,
  reducers: {
    setSinglePatient(state, action) {
      state.data = action.payload;
      state.error = null;
      state.loading = false;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    resetSinglePatient(state) {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
  },
});

export const { setSinglePatient, setLoading, setError, resetSinglePatient } =
  singlePatientSlice.actions;

export const getPatientDetailsFor =
  (clinicId: string, patientId: string) => async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    const unsubscribe = FirestoreService.listenToDocument<Patient>(
      FirestoreCollectionReference.patients(clinicId),
      patientId,
      (singlePatient) => {
        if (singlePatient) {
          dispatch(setSinglePatient(singlePatient));
        }
      },
      (error) => {
        dispatch(setError(error.message));
      },
    );

    return unsubscribe;
  };

export default singlePatientSlice.reducer;
